module.exports = __webpack_public_path__ + "19f69ed23aeb56987a36a00ee350b596.svg";